import Service from '@ember/service';
import { service } from '@ember/service';

export default class ByodMetricsService extends Service {
  @service store;

  async fetchAggregates(
    metricId,
    level = 'month',
    strategy = 'L',
    from = null,
    to = null,
  ) {
    const adapter = this.store.adapterFor('aggregate');
    const params = new URLSearchParams({ level });
    if (strategy) params.set('strategy', strategy);
    if (from) params.set('from', from.length === 7 ? `${from}-01` : from);
    if (to) params.set('to', to.length === 7 ? `${to}-01` : to);

    const url = `${adapter.host}/${adapter.namespace}/metrics/${metricId}/aggregates?${params}`;
    const response = await fetch(url, {
      headers: {
        ...adapter.headers,
        Accept: 'application/x.dataset+json',
      },
    });

    const { source } = await response.json();
    return source;
  }
}
